import { QuestionPage } from '@/components/postPages/QuestionPage';

export default QuestionPage;
